export default __webpack_public_path__ + "static/media/calculator.fdc22a80.svg";